// NOTICE: KAPTION-INTEGRATION
import { frontendURL } from '../../../helper/URLHelper';

const PlaygroundIndex = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/playground'),
    name: 'playground_index',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: PlaygroundIndex,
  },
];
